// extracted by mini-css-extract-plugin
export default {"recipients-table-wrapper":"styles_recipients-table-wrapper__qN-g6","recipientsTableWrapper":"styles_recipients-table-wrapper__qN-g6"};